import Header from "../Components/header";
import Footer from "../Components/footer";
import React, { useState, useEffect } from "react";
import { GraphQLClient } from "graphql-request";
import Markdown from "react-markdown";

const getPage = async (id) => {
  const client = new GraphQLClient(
    "https://api-eu-central-1-shared-euc1-02.hygraph.com/v2/clweq2m6a000001w67aqzeh7x/master"
  );

  const query = `
    query GetText($id: ID!) {
      text(where: { id: $id }) {
        id
        text
      }
    }
  `;

  try {
    const data = await client.request(query, { id });
    return data.text;
  } catch (error) {
    console.error("Error fetching text:", error);
    throw error;
  }
};

const TermsAndConditions = () => {
  const [text, setText] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log("Fetching data for ID:", "cm5rhmt2qlaoz07uqzbp0b4c1");
        const result = await getPage("cm5rhmt2qlaoz07uqzbp0b4c1");
        setText(result.text); // Salva il testo della risposta
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []); // Dipendenza da `showModal` e `id`
  return (
    <div>
      <Header />
      <Markdown className="prose prose-sm max-w-none whitespace-pre-line text-left p-4">
        {text}
      </Markdown>
      <Footer />
    </div>
  );
};

export const PoliticheDiReso = () => {
  const [text, setText] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log("Fetching data for ID:", "cm5rjals2lvbn07w4tzgymhbb");
        const result = await getPage("cm5rjals2lvbn07w4tzgymhbb");
        setText(result.text); // Salva il testo della risposta
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []); // Dipendenza da `showModal` e `id`
  return (
    <div>
      <Header />
      <Markdown className="prose prose-sm max-w-none whitespace-pre-line text-left p-4">
        {text}
      </Markdown>
      <Footer />
    </div>
  );
};

export default TermsAndConditions;
